// Init function — called on initial page load AND after every in-page color
// swap. Re-binds every handler against the fresh DOM, since the section's
// inner HTML is replaced wholesale after each swap (orphaning previous
// listeners). The `root` element itself persists across swaps; only its
// children are replaced. All handlers attach to children, so re-init is safe
// and doesn't duplicate listeners.
function bpdpInit(root){
  if(!root) return;
      // 2026-06-01: Key Highlights drawer toggle (mobile). Lives on .bpdp-hero so it persists across carousel images.
      var _hlBtn = root.querySelector('[data-bpdp-hl-toggle]');
      var _hlBox = root.querySelector('[data-bpdp-hl]');
      if (_hlBtn && _hlBox && !_hlBtn.dataset.hlBound) {
        _hlBtn.dataset.hlBound = '1';
        _hlBtn.addEventListener('click', function(){
          var open = _hlBox.classList.toggle('is-open');
          _hlBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }


  // ---- Hero carousel: sync dots and counter ----
  var track = root.querySelector('#bpdp-hero-track');
  // Promote the L (Look / styled) image to slide 1 on mobile so customers
  // see the full lifestyle shot first. Detected by filename suffix L before
  // the extension (e.g. 23BSH51673L.jpg). Desktop tile grid stays in
  // original order. No-op if the product has no L image.
  if (track && window.innerWidth < 768) {
    var slides = Array.from(track.querySelectorAll('.bpdp-hero-slide'));
    for (var si = 0; si < slides.length; si++) {
      var img = slides[si].querySelector('img');
      if (!img) continue;
      var src = (img.getAttribute('src') || '').split('?')[0];
      if (/L\.(jpe?g|png|webp)$/i.test(src)) {
        if (si > 0) {
          track.insertBefore(slides[si], track.firstElementChild);
          // Force scroll to slide 1 — without this, the browser keeps the
          // previous scrollLeft after the DOM reorder, leaving the carousel
          // visually offset (e.g. showing slide 2 instead of the promoted L).
          // 'auto' = instant; 'smooth' would animate the wrong direction.
          track.scrollTo({ left: 0, behavior: 'auto' });
          // Also schedule a microtask retry in case the browser re-flowed
          // scroll-snap and re-introduced the offset after we set scrollLeft.
          requestAnimationFrame(function () { track.scrollLeft = 0; });
        }
        break;
      }
    }
  }
  var dots  = Array.from(root.querySelectorAll('[data-bpdp-dot]'));
  var countEl = root.querySelector('#bpdp-count-cur');
  function updateActive(){
    if(!track) return;
    var idx = Math.round(track.scrollLeft / track.clientWidth);
    dots.forEach(function(d,i){ d.classList.toggle('is-active', i===idx); });
    if(countEl) countEl.textContent = (idx+1);
  }
  if(track){
    track.addEventListener('scroll', updateActive, {passive:true});
    dots.forEach(function(d){
      d.addEventListener('click', function(){
        var i = parseInt(d.getAttribute('data-bpdp-dot'),10);
        track.scrollTo({left:i*track.clientWidth, behavior:'smooth'});
      });
    });
  }

  // ---- Size selection (in modal) ----
  // Direct AJAX add to cart — no form submission. The size pick handler closes
  // the modal and calls bpdpAddToCart(variantId, intent). On "buy" intent the
  // function redirects to /checkout immediately after a successful add.
  var variantInput = root.querySelector('#bpdp-variant-id');
  var form = root.querySelector('[data-bpdp-form]');
  Array.from(root.querySelectorAll('[data-bpdp-pick-size]')).forEach(function(cell){
    cell.addEventListener('click', function(){
      var vid = cell.getAttribute('data-variant-id');
      if(!vid) return;
      if(variantInput) variantInput.value = vid;
      var m = document.getElementById('bpdp-modal-sizes');
      if(m) m.classList.remove('is-open');
      var intent = form ? (form.getAttribute('data-bpdp-intent') || 'add') : 'add';
      bpdpAddToCart(vid, intent);
    });
  });

  // ---- NOTIFY-ME GO-LIVE SWITCH ----
  // Hidden until launch. Flip to `true` to reveal "NOTIFY ME" on OOS sizes and
  // enable the modal. Backend (/apps/stock-notify) is already wired below.
  window.BPDP_NOTIFY_LIVE = true;
  if(window.BPDP_NOTIFY_LIVE) root.classList.add('bpdp-notify-live');
  /* 2026-06-25 SIZING: expose the verified FIT attribute (attr_fit) + an honest fit hint to JS for the inline size selector. No size_fit/model metafields used (they are empty). */
  /* window.BPDP_FIT is set by the small inline script in the section (it needs Liquid) */
  (function(){
    var f = (window.BPDP_FIT||'').toString().toLowerCase();
    var h='';
    if(f.indexOf('slim')>-1 || f.indexOf('skinny')>-1 || f.indexOf('muscle')>-1){ h=(window.BPDP_FIT||'Slim')+' fit \u2014 if you\u2019re between sizes, size up.'; }
    else if(f.indexOf('regular')>-1 || f.indexOf('comfort')>-1 || f.indexOf('classic')>-1 || f.indexOf('relax')>-1){ h=(window.BPDP_FIT||'Regular')+' fit \u2014 true to size.'; }
    else if(f!==''){ h=(window.BPDP_FIT||'')+' fit \u2014 check the size chart for your best match.'; }
    else { h='Check the size chart for your best match.'; }
    window.BPDP_FIT_HINT = h;
  })();

  // ---- Unavailable size → notify-me modal ----
  Array.from(root.querySelectorAll('[data-bpdp-notify-size]')).forEach(function(cell){
    cell.addEventListener('click', function(){
      if(!window.BPDP_NOTIFY_LIVE) return;   // hidden until go-live
      var size = cell.getAttribute('data-bpdp-notify-size');
      var sku  = cell.getAttribute('data-bpdp-notify-sku') || '';
      var lbl  = root.querySelector('#bpdp-notify-size-label');
      var inp  = root.querySelector('#bpdp-notify-size-input');
      var skuInp = root.querySelector('#bpdp-notify-sku-input');
      if(lbl) lbl.textContent = 'size ' + size;
      if(inp) inp.value = size;
      if(skuInp) skuInp.value = sku;
      // swap modals
      var sm = document.getElementById('bpdp-modal-sizes');
      if(sm) sm.classList.remove('is-open');
      var nm = document.getElementById('bpdp-modal-notify');
      if(nm) nm.classList.add('is-open');
    });
  });

  // ---- Notify-me form submit → bb-notify relay (POST /apps/stock-notify) ----
  var notifyForm = root.querySelector('[data-bpdp-notify-form]');
  if(notifyForm){
    var _nph = notifyForm.querySelector("input[name=phone]");
    if(_nph){ var _cust=(_nph.getAttribute("data-cust-phone")||"").replace(/\D/g,"").slice(-10); if(_cust.length===10){ _nph.value=_cust; _nph.readOnly=true; _nph.classList.add("is-prefilled"); } }
    notifyForm.addEventListener('submit', function(e){
      e.preventDefault();
      var data = Object.fromEntries(new FormData(notifyForm));
      var mobile = String(data.phone || '').replace(/\D/g,'').slice(-10);
      if(!/^\d{10}$/.test(mobile)){ alert("Please enter your mobile number to submit."); return; }
      var btn = notifyForm.querySelector('button[type=submit]');
      if(btn){ btn.disabled = true; btn.textContent = 'Saving...'; }
      // localStorage backup (safety net)
      try{
        var arr = JSON.parse(localStorage.getItem('bpdp_notify_requests') || '[]');
        data.created_at = new Date().toISOString();
        arr.push(data);
        localStorage.setItem('bpdp_notify_requests', JSON.stringify(arr));
      }catch(err){}
      fetch('/apps/stock-notify', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ mobile: mobile, name: data.name || '', email: data.email || '', sku: data.sku || '' })
      }).then(function(r){ return r.ok; }).catch(function(){ return false; }).then(function(){
        if(btn){ btn.textContent = 'WE’LL NOTIFY YOU ✓'; }
        setTimeout(function(){
          var nm = document.getElementById('bpdp-modal-notify');
          if(nm) nm.classList.remove('is-open');
          if(btn){ btn.disabled = false; btn.textContent = 'NOTIFY ME'; }
          notifyForm.reset();
        }, 1400);
      });
    });
  }

  // ---- Color swatch selection (reload to new variant URL when product handle differs) ----
  // For variants within the same product, just update selected state.
  var colorSwatches = Array.from(root.querySelectorAll('[data-bpdp-color]'));
  var colorCurrent = root.querySelector('#bpdp-color-current');
  colorSwatches.forEach(function(sw){
    sw.addEventListener('click', function(){
      colorSwatches.forEach(function(x){ x.classList.remove('is-selected'); });
      sw.classList.add('is-selected');
      if(colorCurrent) colorCurrent.textContent = sw.getAttribute('data-bpdp-color');
      // NOTE: for true variant switching when color is option 1, we'd reload with ?variant=ID.
      // For v1 we only update display; size-pill click drives the variant_id submitted.
    });
  });

  // Form-submit listener removed 2026-05-23.
  // Add-to-cart now happens via the bpdpAddToCart() helper (defined below
  // bpdpInit so it persists across color swaps). Calling AJAX directly
  // avoids form.requestSubmit() edge cases where native form submission
  // would POST to /cart/add and redirect to /cart before our JS could
  // intercept — that was the "going to cart then checkout" bug.
  // Sticky bar opens size modal via existing data-bpdp-open-modal binding.

  // Sticky ATC bar is always visible on mobile (CSS-driven).
  // No JS toggle needed.

  // Fit-guide pills removed 2026-05-23 — section now renders the fit
  // description text directly via Liquid. No JS toggle needed.

  // ---- FAQ accordion — only one Q open at a time ----
  var faqRows = Array.from(root.querySelectorAll('[data-bpdp-faq]'));
  faqRows.forEach(function(row){
    row.addEventListener('click', function(){
      var willOpen = !row.classList.contains('is-open');
      // Close ALL other FAQ rows first
      faqRows.forEach(function(r){
        if(r === row) return;
        if(r.classList.contains('is-open')){
          r.classList.remove('is-open');
          var t = r.querySelector('.bpdp-faq-toggle');
          if(t) t.textContent = '+';
        }
      });
      // Toggle this one
      row.classList.toggle('is-open');
      var toggle = row.querySelector('.bpdp-faq-toggle');
      if(toggle) toggle.textContent = row.classList.contains('is-open') ? '−' : '+';
    });
  });

  // ---- Modals ----
  // When the trigger has data-bpdp-intent ("add" or "buy"), record it on the
  // form so the submit handler knows whether to redirect to /checkout. Also
  // mark the clicked trigger with data-bpdp-active so the loading/success
  // state only updates THAT button (not its sibling).
  Array.from(root.querySelectorAll('[data-bpdp-open-modal]')).forEach(function(t){
    t.style.cursor = 'pointer';
    t.addEventListener('click', function(e){
      e.preventDefault();
      var intent = t.getAttribute('data-bpdp-intent');
      if(intent){
        var f = root.querySelector('[data-bpdp-form]');
        if(f) f.setAttribute('data-bpdp-intent', intent);
      }
      // Clear any previous active marker, mark this one
      Array.from(document.querySelectorAll('[data-bpdp-active]')).forEach(function(el){
        delete el.dataset.bpdpActive;
      });
      t.dataset.bpdpActive = '1';
      var m = document.getElementById(t.getAttribute('data-bpdp-open-modal'));
      if(m) m.classList.add('is-open');
    });
  });
  Array.from(root.querySelectorAll('[data-bpdp-modal]')).forEach(function(m){
    m.addEventListener('click', function(e){
      if(e.target === m || (e.target.hasAttribute && e.target.hasAttribute('data-bpdp-close'))) m.classList.remove('is-open');
    });
  });

  // ---- Collapsible sections (DESCRIPTION, MANUFACTURER, FIT GUIDE, WASH CARE) ----
  // Accordion behaviour — opening any one auto-closes all others. Clicking
  // an already-open header just closes it (no replacement).
  function bpdpCloseAllAccordions(except){
    Array.from(root.querySelectorAll('[data-bpdp-collapse]')).forEach(function(p){
      if(p === except) return;
      if(p.classList.contains('is-collapsed')) return; // already closed
      p.classList.add('is-collapsed');
      var b = p.querySelector('[data-bpdp-collapse-toggle]');
      if(!b) return;
      b.setAttribute('aria-expanded', 'false');
      var i = b.querySelector('.bpdp-collapse-icon');
      if(i) i.innerHTML = '+';
    });
  }
  Array.from(root.querySelectorAll('[data-bpdp-collapse-toggle]')).forEach(function(btn){
    btn.addEventListener('click', function(){
      var parent = btn.closest('[data-bpdp-collapse]');
      if(!parent) return;
      var willOpen = parent.classList.contains('is-collapsed');
      if(willOpen) bpdpCloseAllAccordions(parent);
      var collapsed = parent.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      var icon = btn.querySelector('.bpdp-collapse-icon');
      if(icon) icon.innerHTML = collapsed ? '+' : '&minus;';
    });
  });

  // ===== Rec #3 — Complete the Look on PDP =================================
  // Same algorithm as the cart-drawer CTL:
  //   1. Read SALE products from the prefetched cart cache (sessionStorage)
  //      or fetch a small sample if cache cold.
  //   2. Determine target categories from preferences map (e.g., Shirts →
  //      T-Shirts/Trousers/Jeans).
  //   3. Filter by stock + size availability heuristic (this is the PDP, so
  //      we don't yet know the customer's size — skip strict size filter and
  //      let the picker page handle it).
  //   4. Rank: stock health desc, then price asc.
  //   5. Diversify: max 2 per product_type. Take top 8 for the grid.
  function moneyFmtRec(cents){
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }
  function escHtmlRec(s){
    return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  // Mirrors snippets/bcl-clean-title.liquid — strips "Basics " + "{Fit} Fit "
  function bpdpCleanTitle(t){
    if(t==null) return '';
    var s = String(t);
    s = s.split('Basics ').join('').split('BASICS ').join('').split('basics ').join('');
    var fits = ['Slim Fit ','Tapered Fit ','Regular Fit ','Relaxed Fit ','Comfort Fit ','Muscle Fit ','Skinny Fit ','Super Skinny Fit ','Drift Fit ','Torque Fit ','Blade Fit ','Kerb Fit '];
    for(var i=0;i<fits.length;i++){
      var f = fits[i];
      s = s.split(f).join('').split(f.toLowerCase()).join('').split(f.toUpperCase()).join('');
    }
    return s.trim().replace(/  /g,' ').replace(/  /g,' ');
  }
  var CTL_PDP_PREFS = {
    'SHIRTS':   ['TSHIRTS', 'TROUSERS', 'JEANS'],
    'TROUSERS': ['SHIRTS', 'TSHIRTS', 'JEANS'],
    'JEANS':    ['TSHIRTS', 'SHIRTS', 'SHORTS'],
    'TSHIRTS':  ['SHORTS', 'JEANS'],
    'SHORTS':   ['TSHIRTS'],
    'JACKET':   ['SHIRTS', 'TSHIRTS', 'TROUSERS']
  };
  function ctlNormCatPdp(s){ return String(s||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  function ctlReadCartCache(){
    try {
      var raw = sessionStorage.getItem('blSaleCacheV2');
      if(!raw) return null;
      var obj = JSON.parse(raw);
      if(!obj || !obj.ts || !Array.isArray(obj.products)) return null;
      if((Date.now() - obj.ts) > 30*60*1000) return null;
      return obj.products;
    } catch(e){ return null; }
  }
  function ctlFetchSample(){
    // Cold cache: fetch a small sample of SALE products. We don't fill the
    // full cache here (that's the cart drawer's job) — just enough to render.
    return Promise.all([1, 32, 64, 96].map(function(p){
      return fetch('/collections/sales/products.json?limit=50&page=' + p, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    })).then(function(results){
      var all = [];
      results.forEach(function(r){ if(r && r.products) all = all.concat(r.products); });
      return all;
    });
  }
  function ctlCardHtml(p){
    var img = p.featured_image;
    if(img && typeof img !== 'string') img = img.src || '';
    if(!img && p.images && p.images[0]) img = (typeof p.images[0] === 'string') ? p.images[0] : (p.images[0].src || '');
    // 17 Oct 2026 (speed, his yes): the card shows ~250 px wide but the photo came at full size (1000 px, ~50–90 KB).
    // Ask Shopify's image server for 600 px (sharp on 2–3x phone screens) unless a width is already set.
    if(img && /(cdn\.shopify\.com|\/cdn\/shop\/)/.test(img) && !/[?&]width=/.test(img)) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
    var availPool = (p.variants || []).filter(function(v){ return v.available; });
    var pool = availPool.length ? availPool : (p.variants || []);
    pool = pool.slice().sort(function(a,b){ return Number(a.price) - Number(b.price); });
    var minVar = pool[0] || {};
    var price = Number(minVar.price || 0);
    var compareAt = Number(minVar.compare_at_price || 0);
    var hasDiscount = compareAt > price && price > 0;
    var pct = hasDiscount ? Math.round((1 - price / compareAt) * 100) : 0;
    var isSale = hasDiscount;
    var tags = p.tags;
    if(tags){
      var tagsArr = Array.isArray(tags) ? tags : String(tags).split(',');
      tagsArr.forEach(function(t){ if(String(t).trim().toUpperCase() === 'SALE') isSale = true; });
    }
    // 2026-05-27: SALE/FRESH badges removed per merchant request.
    var badge = '';
    var priceHtml;
    // /collections/X/products.json returns prices in PAISE (cents);
    // sessionStorage cache stores them in rupees (cart drawer normalised).
    // Detect format: if price > 10000 assume paise.
    var priceR, compareR;
    if(price > 10000){ priceR = Math.round(price / 100); compareR = Math.round(compareAt / 100); }
    else { priceR = price; compareR = compareAt; }
    if(hasDiscount){
      priceHtml = '<span class="bpdp-ctl-card-price">' +
        '<span>₹' + priceR.toLocaleString('en-IN') + '</span>' +
        '<span class="bpdp-ctl-card-mrp">₹' + compareR.toLocaleString('en-IN') + '</span>' +
        '<span class="bpdp-ctl-card-off">' + pct + '% off</span>' +
        '</span>';
    } else {
      priceHtml = '<span class="bpdp-ctl-card-price"><span>₹' + priceR.toLocaleString('en-IN') + '</span></span>';
    }
    // Prefer p.url when present (cart-drawer cache normalises this), else
    // derive from p.handle. The /collections/sales/products.json source does
    // NOT include .url, so without this fallback the href was "undefined"
    // → /collections/sales/products/undefined → 404.
    var hrefBpdp = p.url || (p.handle ? '/products/' + p.handle : '#');
    return '<a href="' + hrefBpdp + '" class="bpdp-ctl-card">' +
      '<div class="bpdp-ctl-card-img">' + (img ? '<img src="' + img + '" alt="' + escHtmlRec(p.title) + '" loading="lazy">' : '') + badge + '</div>' +
      '<div class="bpdp-ctl-card-name">' + escHtmlRec(bpdpCleanTitle(p.title)) + '</div>' +
      priceHtml +
      '</a>';
  }
  (function(){
    var sec   = document.getElementById('bpdp-recommended');
    var grid  = document.getElementById('bpdp-rec-grid');
    if(!sec || !grid) return;
    var meType   = ctlNormCatPdp(sec.dataset.productType || '');
    var meHandle = root.dataset.productHandle || '';
    var targets  = CTL_PDP_PREFS[meType] || [];

    function render(pool){
      if(!pool || !pool.length) return;
      // Filter pool: exclude current product, require at least 2 available variants
      var seen = {};
      var primary = [], fallback = [];
      pool.forEach(function(p){
        if(seen[p.id]) return;
        seen[p.id] = 1;
        if(p.handle === meHandle) return;
        var availCount = (p.variants || []).filter(function(v){ return v.available; }).length;
        if(availCount < 2) return;
        var pCat = ctlNormCatPdp(p.product_type || '');
        if(targets.length && targets.indexOf(pCat) !== -1) primary.push(p);
        else fallback.push(p);
      });
      var ranked = (primary.length ? primary : fallback).sort(function(a,b){
        var sa = (a.variants||[]).filter(function(v){ return v.available; }).length;
        var sb = (b.variants||[]).filter(function(v){ return v.available; }).length;
        if(sa !== sb) return sb - sa;
        var pa = (a.variants && a.variants[0] && Number(a.variants[0].price)) || 0;
        var pb = (b.variants && b.variants[0] && Number(b.variants[0].price)) || 0;
        return pa - pb;
      });
      // Diversify: max 2 per product_type, take top 8
      var perCat = {}, picked = [];
      for(var i = 0; i < ranked.length && picked.length < 8; i++){
        var c = ctlNormCatPdp(ranked[i].product_type || '');
        if((perCat[c] || 0) >= 2) continue;
        perCat[c] = (perCat[c] || 0) + 1;
        picked.push(ranked[i]);
      }
      if(!picked.length) picked = ranked.slice(0, 8);
      grid.innerHTML = picked.map(ctlCardHtml).join('');
      sec.style.display = '';
    }

    var cached = ctlReadCartCache();
    if(cached && cached.length){
      render(cached);
    } else {
      // 19 Oct 2026 (speed #71, his yes): the 4 Sale-list pages (~41 KB) used to download while the
      // main photo was still loading. Now they start on the first scroll/touch, or once the page
      // has finished loading, whichever comes first. The row sits far down the page.
      var ctlStarted = false;
      var ctlGo = function(){
        if(ctlStarted) return; ctlStarted = true;
        ['scroll','touchstart','pointerdown','keydown'].forEach(function(t){ window.removeEventListener(t, ctlGo, true); });
        ctlFetchSample().then(render).catch(function(){ /* keep hidden */ });
      };
      ['scroll','touchstart','pointerdown','keydown'].forEach(function(t){ window.addEventListener(t, ctlGo, { passive: true, capture: true }); });
      if(document.readyState === 'complete') setTimeout(ctlGo, 0);
      else window.addEventListener('load', function(){ setTimeout(ctlGo, 0); });
    }
  })();
  // ===== end Rec #3 =========================================================

  // ---- Recently viewed (localStorage) ----
  // Read product info from root.dataset (NOT Liquid bake-in) so values stay
  // correct after a color swap. root.dataset is updated by bpdpSwap().
  var RV_KEY = 'bpdp_recently_viewed';
  var meId = root.dataset.productId;
  var meHandle = root.dataset.productHandle;
  var meTitle = root.dataset.productTitle || '';
  var meImg = root.dataset.productImage || '';
  var mePrice = root.dataset.productPrice || '';
  try{
    var arr = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    arr = arr.filter(function(x){ return x.id !== meId; });
    var others = arr.slice(0, 6);
    if(others.length){
      var box = document.getElementById('bpdp-recently');
      var row = document.getElementById('bpdp-recently-row');
      if(box && row){
        row.innerHTML = others.map(function(x){
          return '<a href="/products/'+x.handle+'" class="bpdp-cross-card"><div class="bpdp-cross-img">'+(x.img?'<img src="'+x.img+'" alt="'+x.title.replace(/"/g,'&quot;')+'" loading="lazy">':'')+'</div><div class="bpdp-cross-name">'+bpdpCleanTitle(x.title)+'</div><div class="bpdp-cross-price">'+x.price+'</div></a>';
        }).join('');
        box.style.display = 'block';
      }
    }
    // store current product at front
    arr.unshift({id:meId, handle:meHandle, title:meTitle, img:meImg, price:mePrice});
    arr = arr.slice(0, 10);
    localStorage.setItem(RV_KEY, JSON.stringify(arr));
  }catch(e){/* localStorage may be blocked */}

  // Wishlist heart removed 2026-05-22.
  // ---- Color swap: AJAX-replace section when a sibling swatch is clicked ----
  // Uses Shopify's Section Rendering API — fetches just this section's HTML
  // for the sibling product, then swaps the inner content of our root div.
  // Browser URL is updated via history.pushState so refresh / share works.
  // Falls back to native navigation if the fetch fails.
  Array.from(root.querySelectorAll('.bpdp-color-swatch')).forEach(function(sw){
    // Only siblings have a meaningful href to a different product page.
    var href = sw.getAttribute('href');
    if(!href || sw.classList.contains('is-selected')) return;
    sw.addEventListener('click', function(e){
      e.preventDefault();
      // Extract handle from href like "/products/buy-basics-..." or absolute.
      var m = href.match(/\/products\/([^?#\/]+)/);
      if(!m) { window.location.href = href; return; }
      window.location.href = href; // AB: colour swap = full reload → fresh variant
    });
  });
}

// Toast helper — shown above the sticky bar for long/error messages that
// won't fit inside a button.
function bpdpToast(message, type, durationMs){
  var existing = document.getElementById('bpdp-toast-el');
  if(existing) existing.remove();
  var el = document.createElement('div');
  el.id = 'bpdp-toast-el';
  el.className = 'bpdp-toast' + (type === 'error' ? ' is-error' : (type === 'success' ? ' is-success' : ''));
  el.textContent = message;
  document.body.appendChild(el);
  var ms = durationMs || 3500;
  setTimeout(function(){
    if(!el.parentNode) return;
    el.style.opacity = '0';
    setTimeout(function(){ if(el.parentNode) el.remove(); }, 300);
  }, ms);
}

// Add-to-cart helper — lives outside bpdpInit so the same function is shared
// across color swaps. Updates ONLY the button the user clicked (marked with
// data-bpdp-active). Long error messages go in a toast, not the button.
function bpdpAddToCart(variantId, intent){
  var btn = document.querySelector('[data-bpdp-active]');
  if(!btn){
    // Fallback: try first sticky half (shouldn't happen in normal flow)
    btn = document.querySelector('#bpdp-sticky .bpdp-sticky-half');
  }
  if(!btn) return;

  var origHtml = btn.innerHTML;
  var isInline = btn.classList.contains('bpdp-atc');
  var inlineInner = isInline ? btn.querySelector('.bpdp-atc-cta') : null;
  var inlineOrigInner = inlineInner ? inlineInner.innerHTML : '';

  btn.style.pointerEvents = 'none';
  if(btn.tagName === 'BUTTON') btn.disabled = true;

  function setBtnState(title, sub){
    if(isInline && inlineInner){
      inlineInner.innerHTML = '<span class="bpdp-atc-title">' + title + '</span>' + (sub ? '<span class="bpdp-atc-sub-cta">' + sub + '</span>' : '');
    } else {
      btn.innerHTML = '<span class="bpdp-sticky-half-title">' + title + '</span>' + (sub ? '<span class="bpdp-sticky-half-sub">' + sub + '</span>' : '');
    }
  }
  function restore(){
    if(isInline && inlineInner){
      inlineInner.innerHTML = inlineOrigInner;
    } else {
      btn.innerHTML = origHtml;
    }
    btn.style.pointerEvents = '';
    if(btn.tagName === 'BUTTON') btn.disabled = false;
    delete btn.dataset.bpdpActive;
  }

  setBtnState('Adding…', '');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type':'application/x-www-form-urlencoded','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
    body: 'id=' + encodeURIComponent(variantId) + '&quantity=1',
    credentials: 'same-origin'
  })
  .then(function(r){
    return r.json().then(function(d){ return {ok: r.ok, data: d}; });
  })
  .then(function(res){
    if(!res.ok) throw new Error(res.data && res.data.description || 'Could not add to cart');
    // Notify the theme so its cart-count badge refreshes
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));

    // ============================================
    // Phase 1 — Fire add_to_cart event (GA4 + Meta + Google Ads)
    // ============================================
    try {
      var atcRoot = document.querySelector('[data-product-id]');
      if (atcRoot) {
        var atcPid = atcRoot.getAttribute('data-product-id');
        var atcTitle = atcRoot.getAttribute('data-product-title');
        var atcPrice = parseFloat((atcRoot.getAttribute('data-product-price') || '0').replace(/[^0-9.]/g, '')) || 0;
        var atcType = atcRoot.getAttribute('data-product-type') || '';
        var atcSizeEl = document.querySelector('.bpdp-size-cell[data-bpdp-selected]');
        var atcSize = atcSizeEl ? (atcSizeEl.getAttribute('data-size') || '') : '';
        var atcItem = { item_id: atcPid, item_name: atcTitle, item_brand: 'Basics', item_category: atcType, item_variant: atcSize, price: atcPrice, quantity: 1 };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'add_to_cart', ecommerce: { currency: 'INR', value: atcPrice, items: [atcItem] } });
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'add_to_cart', { currency: 'INR', value: atcPrice, items: [atcItem] });
        }
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'AddToCart', { content_ids: [atcPid], content_name: atcTitle, content_type: 'product', content_category: atcType, currency: 'INR', value: atcPrice });
        }
      }
    } catch(e) { /* tracking failure shouldn't break ATC */ }

    if(intent === 'buy'){
      setBtnState('REDIRECTING…', '');
      setTimeout(function(){
        if(window.breeze && typeof window.breeze.startCheckout === 'function'){
           window.breeze.startCheckout();
        } else {
          window.location.href = '/checkout';
        }
      }, 200);
    } else {
      setBtnState('✓ ADDED', 'View cart →');
      setTimeout(restore, 1800);
    }
  })
  .catch(function(err){
    // Long error messages (e.g. "The maximum quantity of this item is already in your cart")
    // don't fit in a button — show as a toast above the sticky bar.
    bpdpToast(err.message || 'Could not add to cart', 'error', 4000);
    restore();
  });
}

// Color-swap function — lives outside bpdpInit so it persists across swaps.
// Stage 1: dim section (loading state)
// Stage 2: fetch sibling section HTML via Section Rendering API
// Stage 3: parse response, copy new wrap's data attributes + innerHTML
// Stage 4: re-run bpdpInit on the now-fresh DOM
// Stage 5: update browser URL + scroll the section into view
function bpdpSwap(handle, href, root){
  if(!root) return;
  var sectionId = root.getAttribute('data-section-id') || 'main';
  // Loading state
  root.style.opacity = '0.55';
  root.style.pointerEvents = 'none';
  var oldScrollY = window.scrollY;
  fetch('/products/' + handle + '?section_id=' + encodeURIComponent(sectionId), {
    headers: {'Accept': 'text/html'},
    credentials: 'same-origin'
  })
    .then(function(r){
      if(!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    })
    .then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newWrap = doc.querySelector('#bpdp-' + sectionId);
      if(!newWrap) throw new Error('Could not find #bpdp-' + sectionId + ' in response');
      // Copy fresh data attributes (used by Recently Viewed + recommendations
      // fetch — these read from root.dataset so they must reflect the new product)
      ['productId', 'productHandle', 'productTitle', 'productImage', 'productPrice'].forEach(function(k){
        if(newWrap.dataset[k] != null) root.dataset[k] = newWrap.dataset[k];
      });
      // Swap inner HTML
      root.innerHTML = newWrap.innerHTML;
      // Re-bind all handlers on the new content
      bpdpInit(root);
      // 2026-06-03: re-inject Kiwi's size-chart link for the swapped product — the
      // innerHTML replace wiped Kiwi's injected container and Kiwi doesn't know about
      // our AJAX swap, so without this the native CDN-image fallback shows instead.
      bpdpReinitKiwi(root);
      // Update browser URL (so refresh / share / bookmark works)
      try { history.pushState({bpdp:true, handle:handle}, '', href); } catch(e){}
      // Update page <title> from the new HTML
      var newTitle = doc.querySelector('title');
      if(newTitle && newTitle.textContent) document.title = newTitle.textContent;
      // Restore visual state
      root.style.opacity = '';
      root.style.pointerEvents = '';
      // Keep user roughly where they were (image section stays on screen)
      window.scrollTo({top: oldScrollY, behavior: 'auto'});
    })
    .catch(function(err){
      console.warn('[bpdp] color swap failed, falling back to navigation:', err);
      window.location.href = href;
    });
}

// Re-initialise Kiwi Size Chart after an AJAX colour swap. The innerHTML replace
// wipes Kiwi's injected container, and Kiwi (an app block on the product template)
// doesn't re-run on our in-place swap — so its "Size Chart" link never comes back
// and our native CDN-image fallback modal shows instead (the bug). Re-running Kiwi's
// own loader re-injects its link next to the new SIZE CHART button. Verified:
// loadKiwiSizingChart() with no args re-injects (0 -> 1) after the container is
// removed. Colour siblings share the same garment type, so the chart is correct.
// No-op when Kiwi isn't installed — the native CDN fallback keeps working.
function bpdpReinitKiwi(root){
  try {
    if (typeof window.loadKiwiSizingChart !== 'function') return;
    window.loadKiwiSizingChart();
    // Once Kiwi re-injects its own link, hide our native fallback button so we
    // don't show two triggers. Kiwi injects asynchronously (0-2s) after the loader.
    [400, 1200, 2500].forEach(function(ms){
      setTimeout(function(){
        var kiwiEl = document.querySelector('.ks-chart-modal-link, .sizing-chart-modal-link, .kiwi-sizing-button, .kiwi-sizing-link, [data-kiwi-sizing]');
        if (!kiwiEl) return;
        var nb = (root || document).querySelector('.bpdp-size-chart-link[data-bpdp-size-chart-trigger]');
        if (nb) { nb.style.display = 'none'; nb.setAttribute('data-bpdp-hidden-by-kiwi', '1'); }
      }, ms);
    });
  } catch (_) {}
}

// Browser back/forward — if it landed us on a product handle we know how to
// swap, swap in place rather than reloading.
window.addEventListener('popstate', function(e){
  if(!e.state || !e.state.bpdp) return;
  var root = document.querySelector('.bpdp-wrap');
  if(!root) return;
  bpdpSwap(e.state.handle, location.pathname + location.search, root);
});

// ===== Rec #1 — PDP pincode widget =========================================
// Shares state with the cart drawer via localStorage key blDeliveryPincodeV2.
// India Post API verifies manually-entered pincodes (no geolocation
// auto-detect). All network calls are user-triggered (no page-load cost).
(function(){
  var PINCODE_KEY = 'blDeliveryPincodeV2';
  function readSaved(){
    try { var raw = localStorage.getItem(PINCODE_KEY); if(!raw) return null; var o = JSON.parse(raw); return o && o.pincode ? o : null; }
    catch(e){ return null; }
  }
  function writeSaved(pincode, info){
    try {
      localStorage.setItem(PINCODE_KEY, JSON.stringify({
        pincode: pincode,
        district: (info && (info.city || info.district)) || '',
        state: (info && info.state) || '',
        days: (info && info.days) || 0,
        ts: Date.now()
      }));
    } catch(e){}
  }
  function delivText(days){
    days = parseInt(days, 10) || 0;
    return days > 0 ? ('Delivery in ' + days + (days === 1 ? ' day' : ' days')) : 'Delivery in 4-5 business days';
  }
  function esc(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function renderResult(scope){
    var pillHead = scope.querySelector('.bpdp-pincode-head');
    var inputWrap = scope.querySelector('[data-bpdp-pincode-inputwrap]');
    var msg = scope.querySelector('[data-bpdp-pincode-msg]');
    var resultEl = scope.querySelector('[data-bpdp-pincode-result]');
    var staticEl = scope.querySelector('[data-bpdp-deliv-static]');
    var saved = readSaved();
    if(saved && saved.pincode){
      // Saved state — show result strip, hide pill input
      var place = saved.district ? (esc(saved.district) + (saved.state ? ', ' + esc(saved.state) : '') + ' &mdash; ' + esc(saved.pincode)) : esc(saved.pincode);
      pillHead.style.display = 'none';
      inputWrap.hidden = true;
      msg.hidden = true; msg.innerHTML = '';
      resultEl.hidden = false;
      resultEl.innerHTML = '<span><strong>' + delivText(saved.days) + '</strong> to ' + place + '</span><button type="button" class="bpdp-pincode-result-change" data-bpdp-pincode-open>CHANGE</button>';
      if(staticEl) staticEl.hidden = true; // the generic "3-6 days · COD" line is redundant once we show the pincode-specific result
    } else {
      pillHead.style.display = '';
      inputWrap.hidden = true;
      msg.hidden = true; msg.innerHTML = '';
      resultEl.hidden = true; resultEl.innerHTML = '';
      if(staticEl) staticEl.hidden = false;
    }
  }

  function setMsg(scope, level, html){
    var msg = scope.querySelector('[data-bpdp-pincode-msg]');
    if(!msg) return;
    msg.hidden = false;
    msg.className = 'bpdp-pincode-msg bpdp-pincode-msg--' + level;
    msg.innerHTML = (level === 'info' ? '<span class="bpdp-pin-spinner" aria-hidden="true"></span>' : '') + html;
  }

  function openInput(scope){
    var head = scope.querySelector('.bpdp-pincode-head');
    var inputWrap = scope.querySelector('[data-bpdp-pincode-inputwrap]');
    var input = scope.querySelector('[data-bpdp-pincode-input]');
    var resultEl = scope.querySelector('[data-bpdp-pincode-result]');
    var staticEl = scope.querySelector('[data-bpdp-deliv-static]');
    head.style.display = 'none';
    resultEl.hidden = true;
    inputWrap.hidden = false;
    if(staticEl) staticEl.hidden = false;
    var saved = readSaved();
    if(input){ input.value = (saved && saved.pincode) || ''; setTimeout(function(){ input.focus(); }, 50); }
  }

  function checkPincode(scope){
    var input = scope.querySelector('[data-bpdp-pincode-input]');
    var btn = scope.querySelector('[data-bpdp-pincode-check]');
    if(!input) return;
    var raw = String(input.value || '').trim();
    if(!raw){ setMsg(scope, 'err', 'Please enter your pincode.'); return; }
    // Indian pincodes are pure digits; any letter means a foreign postal code.
    if(/[A-Za-z]/.test(raw)){
      setMsg(scope, 'err', 'Sorry, this item is not delivered outside India.'); return;
    }
    var val = raw.replace(/\D/g, '');
    // A valid Indian pincode is exactly 6 digits and cannot start with 0.
    if(!/^[1-9][0-9]{5}$/.test(val)){
      setMsg(scope, 'err', 'The pincode you entered is wrong. Please enter a valid 6-digit Indian pincode.'); return;
    }
    setMsg(scope, 'info', 'Checking delivery...');
    if(btn) btn.disabled = true;
    var done = false;
    // Delivery days come from Shiprocket via the bb-notify worker (/apps/pincode).
    // A genuine HTTP 200 answer is trusted (real days, or an honest "not
    // serviceable"). If the API is unreachable / errors / rate-limits, we fall
    // back to the default "Delivery in 4-5 business days" so the customer still
    // sees a delivery promise.
    function fail(html){
      if(done) return; done = true;
      if(btn) btn.disabled = false;
      setMsg(scope, 'err', html);
    }
    function softFallback(){
      if(done) return; done = true;
      if(btn) btn.disabled = false;
      writeSaved(val, { city: '', state: '', days: 0 });
      setMsg(scope, 'ok', '<strong>Delivery in 4-5 business days</strong>');
      setTimeout(function(){ renderResult(scope); }, 1100);
    }
    var timeoutId = setTimeout(softFallback, 8000);
    fetch('/apps/pincode/' + encodeURIComponent(val), { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json().then(function(d){ d = d || {}; d.__status = r.status; return d; }).catch(function(){ return { __status: r.status }; }); })
      .then(function(d){
        if(done) return;
        clearTimeout(timeoutId);
        var status = d && d.__status;
        if(status === 400 && d && d.error === 'invalid_pincode'){ fail('The pincode you entered is wrong. Please check and try again.'); return; }
        if(status === 200 && d && typeof d.deliverable !== 'undefined'){
          if(d.deliverable){
            done = true;
            if(btn) btn.disabled = false;
            var days = parseInt(d.estimatedDays, 10) || 0;
            writeSaved(val, { city: d.city || '', state: d.state || '', days: days });
            var place = d.city ? (esc(d.city) + (d.state ? ', ' + esc(d.state) : '')) : esc(val);
            setMsg(scope, 'ok', '<strong>' + delivText(days) + '</strong> to ' + place + '.');
            setTimeout(function(){ renderResult(scope); }, 1100);
            return;
          }
          fail('Sorry, we do not deliver to ' + esc(val) + ' yet.');
          return;
        }
        // Unexpected / error (429/500/502/503/non-JSON) -> default fallback
        softFallback();
      })
      .catch(function(){
        clearTimeout(timeoutId);
        softFallback();
      });
  }

  function wire(scope){
    if(!scope || scope.__bpdpPincodeWired) return;
    scope.__bpdpPincodeWired = true;
    renderResult(scope);
    scope.addEventListener('click', function(e){
      if(e.target.closest('[data-bpdp-pincode-open]')){ e.preventDefault(); openInput(scope); return; }
      if(e.target.closest('[data-bpdp-pincode-check]')){ e.preventDefault(); checkPincode(scope); return; }
    });
    scope.addEventListener('keydown', function(e){
      if(e.key === 'Enter' && e.target.matches('[data-bpdp-pincode-input]')){ e.preventDefault(); checkPincode(scope); }
    });
  }

  function initAll(){
    Array.from(document.querySelectorAll('[data-bpdp-pincode]')).forEach(wire);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
// ===== end Rec #1 ==========================================================

// Initial render — wire up handlers on the server-rendered DOM.
bpdpInit(document.getElementById(window.BPDP_SECTION_ID));
